import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import RestartIcon from '../../HOME/SVG/RestartIcon';
import SurrenderIcon from '../../HOME/SVG/SurrenderIcon';
import OptionsIcon from '../../HOME/SVG/OptionsIcon';
import TrophyIcon from '../../HOME/SVG/TrophyIcon';
import { showLeaderboards, requestSurrender, requestResetStats, setRestart } from '../../HOME/REDUX/actions';
import { windowSize } from '../../HOME/utils';
import { setInit } from '../REDUX/actions';
import { RE_NAVY, RE_YELLOW, RE_PURPLE } from '../const';

const Toolbar = props => {
  const handleSurrender = e => {
    props.hideOptions();

    if (canSurrender()) {
      if (props.over) {
        props.setRestart(true);
      } else {
        props.requestSurrender(true);
      }

      props.requestResetStats(false);
    }
  };

  const handleLeaders = () => {
    props.hideOptions();
    props.showLeaderboards();
  };

  const canSurrender = () => {
    return !props.revealing && (!props.paused || props.over);
  };

  const xmax = windowSize().x;
  const margin = Math.max(5, Math.min(10, xmax / 100));

  const styles = {
    button: { marginLeft: margin, marginRight: margin },
  };

  return (
    <div className="toolbar">
      <span className={`toolbar-button ${canSurrender(props) ? '' : 'toolbar-button-disabled'}`} style={styles.button} onClick={handleSurrender}>
        {props.over ? <RestartIcon width="36" color={RE_NAVY} /> : <SurrenderIcon width="36" color={RE_NAVY} />}
      </span>
      <span className="toolbar-button" style={styles.button} onClick={handleLeaders}>
        <TrophyIcon width="36" color={RE_YELLOW} />
      </span>
      <span className="toolbar-button" style={styles.button} onClick={props.onClickOptions}>
        <OptionsIcon width="36" id="options-button" color={RE_PURPLE} />
      </span>
    </div>
  );
};

function mapStateToProps({ re, common }) {
  return { ...re, ...common };
}

export default connect(
  mapStateToProps,
  { requestResetStats, requestSurrender, showLeaderboards, setInit, setRestart }
)(Toolbar);
